import React from 'react';
import { ReactComponent as FigCreditCard01Component } from './FigCreditCard01.svg';

const FigCreditCard01 = (props) => <FigCreditCard01Component {...props} />;

export default FigCreditCard01;
